var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 600 375"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-reports"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 375
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reports",
    clipPath: "url(#clip-reports)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons_Menu_6_Reports",
    transform: "translate(33.728 63.708)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51",
    transform: "translate(43.366 -63.708)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M148.226,89.8c-42.4,1.785-63.374,2.678-105.326,5.8,7.141,48.2,14.282,96.4,21.869,144.6,37.935,1.785,56.68,2.678,94.615,5.8C155.813,193.787,151.8,142.017,148.226,89.8Z",
    transform: "translate(-42.9 94.184)",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M189.275,70c-44.63,1.785-66.945,3.124-111.575,6.248l8.033,242.34c37.489,3.57,56.68,5.356,94.169,10.265Q184.588,198.98,189.275,70Z",
    transform: "translate(77.18 25.617)",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M253.469,48.4c-47.308,1.781-70.515,2.672-117.823,5.79C127.613,172.212,119.133,290.68,111.1,408.7c37.489,5.344,56.234,8.017,93.276,14.7C220.889,298.252,236.956,173.548,253.469,48.4Z",
    transform: "translate(192.344 -48.4)",
    fill: "#303030"
  }))))));
};
export default __webpack_public_path__ + "static/media/reports.d7ce6335.svg";
export { SvgComponent as ReactComponent };